.Nav {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0px;
    width: 300px;
    background: linear-gradient(180deg, #0a3140 0%, #153d52 100%);
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 1000;
}

.scrollContainer {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

/* Otherwise, use `::-webkit-scrollbar-*` pseudo-elements. Webkit is not supported by firefox only  */
@supports selector(::-webkit-scrollbar) {
    /* Custom scrollbar styles */
    .scrollContainer::-webkit-scrollbar {
        width: 8px;
    }

    .scrollContainer::-webkit-scrollbar-track {
        background: transparent; /* Match the background color */
    }

    .scrollContainer::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2); /* Slightly lighter shade for the thumb */
        border-radius: 4px;
    }

    .scrollContainer::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.2); /* Slightly lighter shade on hover */
    }
}

/* For browsers that support `scrollbar-*` properties. Firefox since 2018. Chrome since Jan 2024.   */
@supports (scrollbar-color: auto) {
    .scrollContainer {
        scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    }
}

.navContent {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.SideMenuItem,
.SideMenuItemActive {
    margin: 0px 0px 8px 0px;
    color: #758c98;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.64px;
    line-height: 21px;
    text-decoration: none;
    padding-left: 32px;
}
.SideMenuItemActive {
    background-color: rgba(255, 255, 255, 0.04);
    border-image: linear-gradient(to bottom, #05a4ee, #006ea2) 1 100%;
    border-width: 5px;
    border-style: solid;
    border-right: 0px;
    border-top: 0px;
    border-bottom: 0px;
    padding-left: 27px;
    color: var(--hps-white);
}

.SideMenuItem:hover,
.SideMenuItemActive:hover {
    color: var(--hps-white);
    text-decoration: none;
}
.Section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 18px;
    width: 100%;
}

.closeMenu {
    margin: 20px 20px 0px 0px;
    display: flex;
    justify-content: flex-end;
}

.closeMenuButton {
    cursor: pointer;
}
